import React, { useState } from 'react';
import { Menu, User } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking-section');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-card/95 backdrop-blur-sm shadow-md border-b border-border' : 'bg-transparent'
    }`}>
      <div className="max-w-[1920px] mx-auto px-6 md:px-10 lg:px-20">
        <div className="flex items-center justify-end h-16">
          {/* Right side only - no logo */}
          <div className="flex items-center gap-3">
            <Button 
              variant="ghost" 
              onClick={scrollToBooking}
              className={`rounded-full px-6 py-2 font-medium transition-colors ${
                isScrolled ? 'hover:bg-muted/70' : 'bg-card/80 backdrop-blur-sm hover:bg-card'
              }`}
              data-testid="nav-book-now-btn"
            >
              Book Now
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;